<template>
  <el-dialog title="新增骑手" :visible="dialogFormVisible" width="800px" :close-on-click-modal="false" @close="close">
    <el-form ref="formData" :model="formData" :rules="rules" label-width="100px">
      <el-form-item label="骑手头像" prop="portrait">
        <custom-upload v-model="formData.portrait"></custom-upload>
      </el-form-item>
      <el-form-item label="骑手账号" prop="userName">
        <el-input v-model="formData.userName" placeholder="请输入登录账号"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password">
        <el-input type="password" v-model="formData.password" placeholder="请输入登录密码"></el-input>
      </el-form-item>
      <el-form-item label="绑定手机号" prop="tel">
        <el-input v-model="formData.tel" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="真实姓名" prop="realName">
        <el-input v-model="formData.realName" placeholder="请填写真实姓名"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="code">
        <el-input v-model="formData.code" placeholder="请输入18位身份证号码"></el-input>
      </el-form-item>
      <el-form-item label="身份证照片">
        <el-row style="width: 500px;">
          <el-col :span="12">
            <el-form-item label-width="0px" prop="frontImg">
              <div class="t_c">
                <span class="fon_12">身份证正面</span>
                <custom-upload v-model="formData.frontImg"></custom-upload>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="0px" prop="backImg">
              <div class="t_c">
                <span class="fon_12">身份证反面</span>
                <custom-upload v-model="formData.backImg"></custom-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="骑手等级">
        <el-select v-model="formData.levelId" :placeholder="$t('common.pleaseSelect')">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="骑手类型">
        <el-select v-model="formData.type" :placeholder="$t('common.pleaseSelect')">
          <el-option label="兼职" value="1"></el-option>
          <el-option label="全职" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="认证状态">
        <el-radio v-model="formData.state" label="1">未认证</el-radio>
        <el-radio v-model="formData.state" label="2">已认证</el-radio>
      </el-form-item>
    </el-form>
    <div style="text-align: right;">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="submitData">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { selectRiderLevel, riderSave } from '@/api/rider';
import customUpload from '@/components/custom-upload.vue';
export default {
  components: { customUpload },
  data() {
    return {
      dialogFormVisible: false,
      formData: {
        userName: '',
        password: '',
        code: '',
        tel: '',
        realName: '',
        portrait: '',
        frontImg: '',
        backImg: '',
        levelId: '',
        state: '1',
        type: '1'
      },
      rules: {
        userName: [{ required: true, message: '请设置骑手账号名称', trigger: 'blur' }],
        password: [{ required: true, message: '请设置密码', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入绑定手机号', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
				code:[{ required: true, message: '请输入骑手身份证号', trigger: 'blur' }],
        portrait: [{ required: true, message: '请输上传骑手头像', trigger: 'blur' }],
        frontImg: [{ required: true, message: '请输上传身份证正面图像', trigger: 'blur' }],
        backImg: [{ required: true, message: '请输上传身份证反面图像', trigger: 'blur' }]
      },
      options: []
    };
  },
  created() {
    selectRiderLevel().then((res) => {
      if (res.code == 1) {
        this.formData.levelId = res.data[0].id;
        this.options = res.data;
      }
    });
  },
  methods: {
    // 初始化
    init() {
      this.dialogFormVisible = true;
    },
    // 上传图片
    upSuccess(key, res) {
      this.formData[key] = res;
    },
    // 关闭页面
    close() {
      this.dialogFormVisible = false;
      this.$emit('close');
    },
    // 表单提交
    submitData() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          const { msg } = await riderSave(this.formData);
          this.$baseMessage(msg, 'success');
          this.$emit('refreshData');
          this.close();
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped></style>